<template>
  <div class="page">
    <van-nav-bar title="我的方向" left-arrow @click-left="$router.back()"/>
    <section class="intro"><b>基于最终复核分、可信情报与平台表现</b>
      <p>平台数据仅作品牌运营观察，不计入绩效；来源与未知项会一并保留。</p>
      <van-button block type="primary" :loading="generating" @click="generate">生成 3 条方向建议</van-button>
    </section>
    <section v-for="row in rows" :key="field(row,'id')" class="advice"><h2>{{ parsed(row).title }}</h2>
      <p>{{ parsed(row).summary }}</p><small>置信度 {{ Math.round((parsed(row).confidence || 0) * 100) }}%</small>
      <div v-for="(s,i) in parsed(row).suggestions||[]" :key="i" class="suggestion"><b>{{ i + 1 }}. {{
          s.direction
        }}</b><em>{{ s.targetPlatform || '平台待验证' }} · {{ s.contentType || '形式待验证' }} · {{ s.publishWindow || '时段待验证' }}</em>
        <p>{{ s.reason }}</p>
        <ul>
          <li v-for="a in s.actions" :key="a">{{ a }}</li>
        </ul>
      </div>
      <van-button size="small" type="danger" :loading="dispatching===field(row,'id')" @click="addToday(row)">加入今日任务</van-button>
    </section>
    <van-empty v-if="!rows.length&&!generating" description="尚未生成方向建议"/>
  </div>
</template>
<script>import api from '@/api/brand';

export default {
  data() {
    return {rows: [], generating: false, dispatching: null}
  }, created() {
    this.load()
  }, methods: {
    field(r, k) {
      return r[k] !== undefined ? r[k] : r[k.toUpperCase()]
    }, parsed(r) {
      const v = this.field(r, 'advice_json');
      if (typeof v === 'object') return v;
      try {
        return JSON.parse(v || '{}')
      } catch (e) {
        return {}
      }
    }, async load() {
      try {
        this.rows = await api.advices({scopeType: 'PERSONAL', targetEmployeeId: localStorage.getItem('CoreEmployeeId')})
      } catch (e) {
        this.$toast.fail(e.message)
      }
    }, async generate() {
      this.generating = true;
      try {
        await api.generateAdvice({scopeType: 'PERSONAL', targetEmployeeId: Number(localStorage.getItem('CoreEmployeeId'))});
        await this.load();
        this.$toast.success('方向建议已生成')
      } catch (e) {
        this.$toast.fail(e.message)
      } finally {
        this.generating = false
      }
    }, async addToday(row) {
      this.dispatching = this.field(row, 'id');
      try {
        await api.dispatchAdvice(this.field(row, 'id'), Number(localStorage.getItem('CoreEmployeeId')));
        this.$toast.success('已加入现有任务列表，权重为 0')
      } catch (e) {
        this.$toast.fail(e.message)
      } finally {
        this.dispatching = null
      }
    }
  }
};</script>
<style lang="less" scoped>
@import "./brand-page.less";

.intro, .advice {
  padding: .28rem
}

.intro {
  border-top: .06rem solid #d32f2f
}

.intro b, .advice h2 {
  margin: 0;
  color: #34364a;
  font-size: .35rem
}

.intro p, .advice > p {
  margin: .12rem 0 .22rem;
  color: #777b8e;
  font-size: .27rem;
  line-height: 1.65
}

.advice h2 {
  padding: 0
}

.advice small {
  display: inline-flex;
  margin: .06rem 0 .18rem;
  padding: .06rem .14rem;
  border-radius: .06rem;
  color: #9f2424;
  background: #fff0f0;
  font-size: .24rem
}

.suggestion {
  padding: .22rem 0;
  border-top: 1px solid #eceef3
}

.suggestion b {
  color: #34364a;
  font-size: .3rem;
  line-height: 1.5
}

.suggestion p {
  margin: .1rem 0;
  color: #777b8e;
  font-size: .26rem;
  line-height: 1.6
}

.suggestion ul {
  margin: .12rem 0;
  padding-left: .38rem;
  color: #5f6375;
  font-size: .26rem;
  line-height: 1.7
}

.advice /deep/ .van-button--small {
  height: .64rem;
  padding: 0 .24rem;
  border-radius: .08rem
}

.suggestion em {
  display: block;
  margin-top: .08rem;
  color: #9f6a20;
  font-size: .23rem;
  font-style: normal
}
</style>



// WEBPACK FOOTER //
// src/views/brand/MyDirection.vue